"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _browserKey = _interopRequireDefault(require("../browser-key"));

/**
 * NodeJS app-config loader -- but in the browser
 *
 * The expectation is that runtime libraries will inject the below global into
 * the environment with the appropriate browser settings.
 */
try {
  // Surround in try/catch because process.env is not polyfilled in all build environments
  if (process.env.NODE_ENV !== 'production' && !window[_browserKey.default]) {
    // eslint-disable-next-line
    console.error("Unable to load browser app-config in window[".concat(_browserKey.default, "]. See https://github.com/NerdWallet/app-configs"));
  } // eslint-disable-next-line no-empty

} catch (e) {}

var _default = window[_browserKey.default];
exports.default = _default;